"use client";

import useLoginStore from "@/util/store/useLoginStore";
import useUserStore from "@/util/store/user";
import { CircleUserRound, UserRound } from "lucide-react";
import Link from "next/link";

const ProfileHeader = () => {
    const { token } = useUserStore();
    const { openLogin } = useLoginStore()

    if (!token) {
        return (
            <div className="mx-1" role="button" onClick={() => openLogin()}>
                <UserRound aria-hidden="true" className="text-text1 size-6" />
            </div>
        );
    }
    return (
        <Link href="/profile" className="mx-1">
            <CircleUserRound aria-hidden="true" className="text-text1 size-6" />
        </Link>
    );
};

export default ProfileHeader;
